module.exports = __webpack_public_path__ + "img/logos-logo-up.104d5917.png";